import { renderSlot as _renderSlot, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-504ef3e9")

_pushScopeId("data-v-504ef3e9")
const _hoisted_1 = {
  ref: "content",
  class: "transition-height-content"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: "wrapper",
    class: "transition-height",
    onTransitionend: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('heightChanged')), ["self"]))
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512)
  ], 544))
})